var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/sliderIcon.9601c928.png","uri@2x": __webpack_public_path__ + "static/media/sliderIcon.01d67b76.png","uri@3x": __webpack_public_path__ + "static/media/sliderIcon.9ce958b7.png",
    width: 8,
    height: 8
});